import NudgedRow from '../store/schema/NudgedRow';
import { getStore } from '../store/Store';
import { isFeatureEnabled } from 'owa-feature-flags';

/**
 * In the "crawl" phase of spotlight, spotlightt items will be 0-day nudges, so
 * this selector determines if a row should appear as a spotlight row by checking
 * if it's part of the collection of nudged rows and that is from today (0 days ago).
 */
export default function shouldShowAsSpotlight(rowKey: string, tableViewId: string): boolean {
    // Don't show any row as a spotlight row if feature is not enabled.
    if (!isFeatureEnabled('tri-spotlight')) {
        return false;
    }

    return getStore().nudgedRows.some(
        (nudgedRow: NudgedRow) =>
            nudgedRow.rowKey === rowKey &&
            nudgedRow.tableViewId === tableViewId &&
            nudgedRow.daysAgo === 0
    );
}
